module.exports = __webpack_public_path__ + "assets/img/嘉仕达.a6b6ca63.png";